module.exports = "/_next/static/images/ThomasWyatt-96e8a32d4419d87f3a94a7e23ebf7b3a.png";